module.exports = __webpack_public_path__ + "img/photo3@2x.62064fc1.png";